module.exports = __webpack_public_path__ + "static/media/21ECLAC38.f1672b7d.jpg";